import React, { useState, useCallback } from "react";
import cn from "classnames";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import styles from "./styles/form-advanced-field.css.js";
import withStyles from "components/with-styles";

const FormAdvancedField = ({
  children,
  label,
  intl,
  classes,
  onVisibilityChange = () => {},
  className,
  textClassname,
}) => {
  const [show, setShow] = useState(false);
  const linkText = label || intl.formatMessage({ id: "app.form.advanced" });

  const handleShow = useCallback(
    () => {
      setShow(!show);
      onVisibilityChange(!show);
    },
    [onVisibilityChange, show],
  );

  return (
    <div className={cn(classes.container, className)}>
      <div className={classes.button} onClick={handleShow}>
        <div className={cn(classes.link, textClassname)}>
          {show ? "[-] " : "[+] "}
          {linkText}
        </div>
      </div>
      {show && <div className={classes.content}>{children}</div>}
    </div>
  );
};

FormAdvancedField.propTypes = {
  /**
   * Callback que se llama cuando el campo avanzado se muestra
   */
  onVisibilityChange: PropTypes.func,
  /**
   * Texto del enlace para mostrar el campo
   */
  label: PropTypes.string,
  /**
   * Clase adicional del componente
   */
  className: PropTypes.string,
  /**
   * Clase adicional del texto
   */
  textClassname: PropTypes.string,
};

export default withStyles(styles)(injectIntl(FormAdvancedField));
